import AccordionCard from "../shared/AccordionCard";

interface DeceptionSignalsCardProps {
  confidence: string;
  offCameraFrames: string;
  multiplePersonFrames: string;
  samePersonFrames : string;
}

function DeceptionSignalsCard({
  // confidence,
  offCameraFrames,
  multiplePersonFrames,
  samePersonFrames
}: DeceptionSignalsCardProps) {
  const items = [
    // {
    //   label: "Confidence",
    //   value: confidence,
    // },
    {
      label: "Off Camera",
      value: offCameraFrames,
    },
    {
      label: "Multiple Person",
      value: multiplePersonFrames,
    },
    {
      label: "Same Person",
      value: samePersonFrames,
    }
  ];

  return (
    <AccordionCard title="DECEPTION SIGNALS">
      <div className="metric-grid">
        {items.map((item) => (
          <div
            key={item.label}
            className="metric-tile"
          >
            <span className="metric-tile__label">
              {item.label}
            </span>

            <strong className="metric-tile__value">
              {item.value}
            </strong>
          </div>
        ))}
      </div>
    </AccordionCard>
  );
}

export default DeceptionSignalsCard;